<template>
  <loader
    v-if="!settProfile || loading"
    :class="$style.loader"
  />
  <div
    v-else
    :class="[$style.form, $style.formColumn]"
  >
    <div :class="$style.formTitle">
      {{ $t('settings.selectRegularExpression') }}
    </div>
    <div
      v-for="rule in rules"
      :key="rule.ruleId"
      :class="$style.formInput"
    >
      <input
        :id="`rule_${rule.ruleId}`"
        v-model="rule.checked"
        type="checkbox"
        :name="`rule_${rule.type}`"
        :class="$style.checkbox"
        @click="checkedRule($event, rule)"
      >
      <label @click="viewCurrentRule(rule)">
        {{ $t(`settings.ruleIdName.${rule.ruleId}`) }}
      </label>
    </div>
    <div
      v-if="currentRule"
      :class="$style.formTitle"
    >
      {{ $t('settings.exampleOfAnExpression') }}: {{ currentRule.comment }}
    </div>
  </div>
</template>
<script>
  import Loader from '@/components/common/blocks/loader.vue';
  import { getSecurityRules } from '@/api/methods/security';
  import { cloneDeep } from 'lodash';

  export default {
    components: {
      Loader,
    },
    data() {
      return {
        loading: false,
        rules: [],
        initRules: [],
        currentRule: null,
      };
    },

    computed: {
      settProfile() {
        return this.$store.getters['settings/profile'];
      },
      selectedComputer() {
        return {
          type: this.$route.params.type,
          id: this.$route.params.computer,
        };
      },
    },
    async created() {
      if (this.selectedComputer.id) {
        try {
          this.loading = true;
          const { data } = await getSecurityRules(this.selectedComputer.id, this.selectedComputer.type, 99);
          if (data) {
            this.rules = data.result.rules.map((rule) => ({
              ...rule,
              checked: rule.id > 0,
            }));
            this.initRules = cloneDeep(this.rules);
          }
        } catch (err) {
          console.error(err);
        } finally {
          this.loading = false;
        }
      }
    },

    mounted() {
      this.unsubscribe = this.$store.subscribeAction({
        // eslint-disable-next-line
        after: async (action) => {
          if (action.type === 'settings/cancel') {
            this.rules = cloneDeep(this.initRules);
          }
        },
      });
    },

    beforeDestroy() {
      if (this.unsubscribe) {
        this.unsubscribe();
      }
    },
    methods: {
      checkedRule(evt, rule) {
        const { checked } = evt.target;
        rule.checked = checked;
        if (rule.ruleId) this.$store.commit('settings/addSecurity', rule);
      },
      viewCurrentRule(rule) {
        this.currentRule = rule;
      },
    },
  };
</script>
<style lang="scss" module>
  .form {
    font-style: normal;
    font-size: 14px;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    flex: 2;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    margin: 5px 0px 15px 22px;
    width: 92%;
    padding: 5px;
  }
  .formLeft {
    flex: 1;
  }

  .formColumn {
    display: flex;
    flex-direction: column;
  }

  .formTitle {
    font-size: 15px;
    padding: 10px;
  }
  .formInput {
    display: flex;
    align-items: center;
    cursor: pointer;
    gap: 5px;
    margin-left: 10px;
    & * {
      cursor: pointer;
    }
    & input {
      flex-shrink: 0;
      margin: 0;
    }
    & label:hover {
      text-decoration: underline;
    }
  }
</style>
